export function getReminderStageLabel(stage: number): string {
	if (stage <= 0) return "Keine";
	if (stage === 1) return "Zahlungserinnerung";
	return `${stage - 1}. Mahnung`;
}
